module.exports = __webpack_public_path__ + "static/media/image.7f5a24a1.svg";